import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SALES_SCREEN_PATH } from "@/lib/sales-display-preview";

/**
 * Adressen man setter opp en salgsskjerm på.
 *
 * Bygges fra `window.location.origin`, ikke fra en hardkodet URL: da peker den
 * på det miljøet du faktisk står i, og en adresse kopiert fra staging tar deg
 * ikke til prod-tall ved et uhell.
 *
 * Skjermen må være innlogget med en konto som har `display`-tilgang. Adressen er
 * ikke en offentlig lenke — uten session havner TV-en på innloggingssiden, og
 * uten rollekravet ville enhver innlogget bruker, også eksterne, fått
 * salgstallene i en ferdig fullskjermsflate.
 */
export function SalesScreenAddress() {
  const [copied, setCopied] = useState(false);
  const url = `${window.location.origin}${SALES_SCREEN_PATH}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Utklippstavlen krever sikker kontekst og kan være blokkert. Feltet er
      // markerbart, så adressen er ikke utilgjengelig om dette ikke går.
      toast.error("Fikk ikke kopiert. Marker adressen og kopier manuelt.");
    }
  };

  return (
    <div className="space-y-2 rounded-lg border bg-muted/30 p-4">
      <div>
        <h3 className="font-medium">Adresse for salgsskjermene</h3>
        <p className="text-sm text-muted-foreground">
          Åpne denne på skjermen og logg inn én gang. Den viser loopen i fullskjerm,
          uten meny. Skjermen må være innlogget med en konto som har «Display» i
          menyen — adressen er ikke en åpen lenke.
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        <Input readOnly value={url} aria-label="Adresse for salgsskjermene" className="min-w-0 flex-1 font-mono text-sm" />
        <Button variant="outline" onClick={copy}>
          {copied ? "Kopiert" : "Kopier"}
        </Button>
        <Button variant="outline" asChild>
          <a href={SALES_SCREEN_PATH} target="_blank" rel="noreferrer">
            Åpne
          </a>
        </Button>
      </div>
    </div>
  );
}
